import type { BikeTypeV2 } from "@jobrad-gmbh/bike-leasing-calculator";
import { getDefaultBikePrice } from "../../state";

export const overridePrices = (
  newBikeType: BikeTypeV2,
  oldBikeType: BikeTypeV2,
  currentPurchasePrice: number,
  currentUVP: number,
): { purchasePrice: { override: boolean; newValue: number }; uvp: { override: boolean; newValue: number } } => {
  const newDefaultBikePrice = getDefaultBikePrice(newBikeType);
  const currentDefaultBikePrice = getDefaultBikePrice(oldBikeType);

  const overridePurchasePrice = currentPurchasePrice === currentDefaultBikePrice;
  const overrideUVP = overridePurchasePrice && currentUVP === currentDefaultBikePrice;
  return {
    purchasePrice: { override: overridePurchasePrice, newValue: newDefaultBikePrice },
    uvp: { override: overrideUVP, newValue: newDefaultBikePrice },
  };
};
